import { gql } from '@apollo/client';

export default gql`
  mutation addTodo($newtodo: newInput!) {
    addTodo(newtodo: $newtodo) {
      payload {
        _id
        title
        item
      }
      message
      status
    }
  }
`;
